import React, { Component } from "react"
import "./Flip.scss"
import FlipItem from "./FlipItem";
import _FlipData from "../../../api/Flip.json"
import { push } from "../../Services/Analytics";

class Flip extends Component {
    constructor(props) {
        super();
        this.state = {
            currentFlip: 0,
            flipSide: -1
        }
        this.setflipSide = this.setflipSide.bind(this);
        this.handlePaging = this.handlePaging.bind(this);
    }
    handlePaging(num) {
        num = (num <= 0 ? 0 : num);
        // num = (num >= _FlipData.length ? _FlipData.length - 1 : num);
        num = (num >= _FlipData.length ? 0 : num);

        this.setState({
            currentFlip: num,
            flipSide: -1
        })
    }
    setflipSide(index)  {
        // push("Whats_more", _FlipData[this.state.currentFlip].name)
        this.setState({
            flipSide: index
        })
    }
    render() {
        return (
            <div className="flips">
                <div className="desc">{_FlipData[this.state.currentFlip].name}</div>
                <div className="items">
                    <FlipItem
                        key={0}
                        index={0}
                        length={_FlipData.length}
                        ID={this.state.currentFlip}
                        link={_FlipData[this.state.currentFlip].purchaseLink}
                        purchaseBtn={_FlipData[this.state.currentFlip].purchaseButton}
                        HTML={_FlipData[this.state.currentFlip].HTML}
                        data={_FlipData[this.state.currentFlip].answers[0]}
                        currentFlip={this.state.currentFlip}
                        flipSide={this.state.flipSide}
                        setflipSide={this.setflipSide}
                        handlePaging={this.handlePaging}
                    />
                    <FlipItem
                        key={1}
                        index={1}
                        length={_FlipData.length}
                        ID={this.state.currentFlip}
                        link={_FlipData[this.state.currentFlip].purchaseLink}
                        purchaseBtn={_FlipData[this.state.currentFlip].purchaseButton}
                        HTML={_FlipData[this.state.currentFlip].HTML}
                        data={_FlipData[this.state.currentFlip].answers[1]}
                        currentFlip={this.state.currentFlip}
                        flipSide={this.state.flipSide}
                        setflipSide={this.setflipSide}
                        handlePaging={this.handlePaging}
                    />
                </div>
            </div>
        )
    }
}

export default Flip;


// WEBPACK FOOTER //
// ./src/Components/FakeStats/Flip/Flip.jsx